<div class="errors" [class.mod-collapse]="collapseMargin" *ngIf="validate && errorKeys">
  <ng-container *ngFor="let error of errorKeys">
    <span class="error">{{(getLocalizedError(error)) | translate}}</span>
  </ng-container>
</div>
